module.exports = "<div\r\n  #containerDiv\r\n  class=\"container\"\r\n  [style.height]=\"containerSize\"\r\n  (scroll)=\"onScroll()\"\r\n>\r\n  <div\r\n    class=\"scroll\"\r\n    [style.height]=\"contentSize\"\r\n  ></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/side-menu-scroller/side-menu-scroller.component.html
// module id = ../../../../../src/app/components/common/side-menu-scroller/side-menu-scroller.component.html
// module chunks = 0